<template>
    <div class="input-number-container">
        <input
            :min="min"
            :max="max"
            :value="value"
            type="number"
            name=""
            class="form-control input-number__input"
            data-container="body"
            disabled
        >
        <div class="btn-toggle__container">
            <button
                type="button"
                class="btn btn-toggle__inc"
                role="button"
                @click="increment"
            />
            <button
                type="button"
                class="btn btn-toggle__dec"
                role="button"
                @click="decrement"
            />
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    props: {
        value: {
            type: Number,
            default: 0,
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 20,
        },
        day: {
            type: String,
            default: 'monday',
        },
        basket: {
            type: Object,
            required: true,
        },
        editBasket: {
            type: Function,
            required: true,
        },
        changeOnRecommendations: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters([
            'people',
            'sortedBasketsPeopleMonday',
            'sortedBasketsPeopleWednesday',
        ]),
    },
    watch: {
        people() {
            if (this.changeOnRecommendations) {
                this.checkBasketsValue();
            }
        },
    },
    methods: {
        async checkBasketsValue() {
            await this.updateInput(0, true);
            if (this.day === 'monday') {
                const basketsBasedOnWeight = this.sortedBasketsPeopleMonday.filter(basket => basket.kg === this.basket.kg);
                this.updateWithRecommendations(basketsBasedOnWeight.length);
            } else {
                const basketsBasedOnWeight = this.sortedBasketsPeopleWednesday.filter(basket => basket.kg === this.basket.kg);
                this.updateWithRecommendations(basketsBasedOnWeight.length);
            }
        },
        updateWithRecommendations(length) {
            if (this.value < length) {
                this.updateInput(length);
            } else if (this.value > length) {
                this.updateInput(length);
            }
        },
        increment() {
            if (this.value < this.max) {
                this.updateInput(this.value + 1);
            }
        },
        decrement() {
            if (this.value > this.min) {
                this.updateInput(this.value - 1);
            }
        },
        // handleInput(e) {
        //     const value = parseInt(e.target.value, 10);

        //     if (value) {
        //         if (value < this.min) {
        //             this.updateInput(this.min);
        //         } else if (value > this.max) {
        //             this.updateInput(this.max);
        //         } else {
        //             this.updateInput(value || this.min);
        //         }
        //     }
        // },
        updateInput(value, removeallById = false) {
            const { day, basket } = this;
            this.editBasket({ day, basket, value, removeallById });
        },
    },
};
</script>



// WEBPACK FOOTER //
// BasketInput.vue?869d5000